export default __webpack_public_path__ + "97db9d56f1edc893304f1a2258ff5028.png";